export const defaultViewMeta = {
    name: 'default',
};
//# sourceMappingURL=const.js.map